import React, {useState, useRef} from "react";
import {connect} from 'react-redux';
import {fetch_books, changePage, chRecViewed} from "./action/books";
import {FaSearch, FaAngleLeft, FaAngleRight} from "react-icons/fa";
import ZoomIn from "../../img/ZoomIn.png";
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";

function PageRenderingEngine ({pdfDoc, pageNo, scale}) {
    const canvasRef = useRef();
    renderPage(pageNo, pdfDoc);
    function renderPage(pageNo, pdfDoc){
        pdfDoc && pdfDoc.getPage(pageNo).then((currentPage) => {
            const viewport = currentPage.getViewport({scale: scale});
            const canvas = canvasRef.current;
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            const renderContext = {
                canvasContext: canvas.getContext('2d'),
                viewport: viewport
            };
            currentPage.render(renderContext);
        })
    };

    return <canvas ref={canvasRef}></canvas>; 
}
            // {for(i = 1; i <= totalPages; i++){
            //     console.log(i);
            // }}

function PDFReader({pdfDoc}){
    const [pageNo, setPageNo] = useState(1);
    const [pdfNavDisplay, setPdfNavDisplay] = useState(1);
    const [scale, setScale] = useState(1.5);
    const [searchToogled, setSearchToogled] = useState(false);
    var totalPages = pdfDoc._pdfInfo.numPages;
    onchange = (e) =>{
        if(e.target.value>=1 && e.target.value < totalPages+1){
            setPageNo(e.target.value*1);
        }
    };
    const previousPage = () =>{
        if(pageNo>1 && pageNo < totalPages+1){
            setPageNo(pageNo - 1);
        };
    };
    const nextPage = () =>{
        if(pageNo>=1 && pageNo < totalPages){
            setPageNo(pageNo + 1);
        };
    };
    
    return(
        <div>
            <div className="pdfNav">
                <h3>Current Reading Page <input type="number" value={pageNo} onChange={onchange}/> of {totalPages}</h3>
                <div className="zoomButtons">
                    <div className="circle mr-3" onClick = {() => {previousPage()}}>
                        <h1><FaAngleLeft/></h1>
                    </div>
                    <div className="circle mr-3" onClick = {() => {nextPage()}}>
                        <h1><FaAngleRight/></h1>
                    </div>
                    <div className="circle" onClick = {() => setScale(scale+0.25)}>
                        <h1>+</h1>
                    </div>
                    <div className="circle ml-3" onClick = {() => setScale(scale-0.25)}>
                        <h1>-</h1>
                    </div>
                </div>
                <input type = "text" className="searchBarPdfNav" placeholder="Find in Book"/>
                <div className="responsiveSearchBarPdfNav">
                    <FaSearch className="faSearchIconInResponsiveSearchBarPdfNav" onClick = {() => {setSearchToogled(true)}} />
                    {searchToogled && (
                        <div>
                            <div className="hideOnClick" onClick = {() => {setSearchToogled(false)}}></div>
                            <input type="text" placeholder="Find In Book"
                            />
                        </div>
                    )
                    }
                </div>
            </div>
            <div className="pdfReaderContainer">
                <div className="pdfReader">
                    <PageRenderingEngine pdfDoc = {pdfDoc} pageNo = {pageNo} scale={scale}/>
                </div>
            </div>
        </div>
    );
};

function PDFReaderNoDisturbance({pdfDoc, bookName, switchNormalMode}){
    const [pageNo, setPageNo] = useState(1);
    const [pdfNavDisplay, setPdfNavDisplay] = useState(1);
    const [scale, setScale] = useState(1.5);
    var totalPages = pdfDoc._pdfInfo.numPages;
    onchange = (e) =>{
        if(e.target.value>=1 && e.target.value < totalPages+1){
            setPageNo(e.target.value*1);
        }
    };
    const previousPage = () =>{
        if(pageNo>1 && pageNo < totalPages+1){
            setPageNo(pageNo - 1);
        };
    };
    const nextPage = () =>{
        if(pageNo>=1 && pageNo < totalPages){
            setPageNo(pageNo + 1);
        };
    };
    document.querySelector(".topSection").style.display = 'none';
    document.querySelector(".menu_bar_buttons").style.display = 'none';
    document.querySelector(".mainController").style.paddingTop = '0';
    document.querySelector(".dekho").style.display = 'none';
    return(
        <div>
            <div className="pdfNav noDisturbanceModeTop">
                <div>
                    
                </div>
                <h3>{bookName}</h3>
                <h1 className="noDisturbanceMode" onClick={switchNormalMode}><input type="checkbox" />Enter in Distraction Free Mode</h1>
            </div>
            <div className="pdfNav noDisturbanceMode">
                <h3>Current Reading Page <input type="number" value={pageNo} onChange={onchange}/> of {totalPages}</h3>
                <div className="zoomButtons">
                    <div className="circle mr-3" onClick = {() => {previousPage()}}>
                        <h1><FaAngleLeft/></h1>
                    </div>
                    <div className="circle mr-3" onClick = {() => {nextPage()}}>
                        <h1><FaAngleRight/></h1>
                    </div>
                    <div className="circle" onClick = {() => setScale(scale+0.25)}>
                        <h1>+</h1>
                    </div>
                    <div className="circle ml-3" onClick = {() => setScale(scale-0.25)}>
                        <h1>-</h1>
                    </div>
                </div>
                <input type = "text" className="searchBarPdfNav" placeholder="Find in Book"/>
            </div>
            <div className="pdfReaderContainer noDisturbanceMode">
                <div className="pdfReader ml-0">
                    <PageRenderingEngine pdfDoc = {pdfDoc} pageNo = {pageNo} scale={scale}/>
                </div>
            </div>
        </div>
    );
};


class ReadBookPDF extends React.Component{
    state = {
        loading: true,
        noDisturbanceMode: false
    };
    constructor(props) {
      super(props);
    
      var LoadedDocument = null;
    }
    componentDidMount(){
        if(this.props.chRecViewed){
            var date = new Date();
            var toSend = date.getDate()+date.getMonth()+date.getFullYear()+date.getHours()+date.getMinutes();
            this.props.chRecViewed(toSend)
        };
        document.querySelector(".createBookIconReadBook").style.display = "none";
        if(this.props.books){
        console.log(this.props);
            var url = "/root/user/"+this.props.books[this.props.match.params.bookId].book_file;
            const loadingTask = pdfjsLib.getDocument(url);
            loadingTask.promise.then(doc => {
                if(doc){
                    this.LoadedDocument = doc;
                    this.setState({loading: false});
                }
            }).catch(msg => {
                this.setState({error: "PDF Document is not uploaded"})
            })
        }else{
            this.props.fetch_books().then(books => {
                var url = "/root/user/"+this.props.books[this.props.match.params.bookId].book_file;
                const loadingTask = pdfjsLib.getDocument(url);
                loadingTask.promise.then(doc => {
                    if(doc){
                        this.LoadedDocument = doc;
                        this.setState({loading: false});
                    }
                }).catch(msg => {
                    this.setState({error: "PDF Document is not uploaded"})
                })
            });
        }
    };
    switchNormalMode = () => {
        this.setState({noDisturbanceMode: false});
        document.querySelector(".topSection").style.display = 'flex';
        document.querySelector(".menu_bar_buttons").style.display = 'flex';
        document.querySelector(".mainController").style.paddingTop = '12%';
        document.querySelector(".dekho").style.display = 'block';
    }
    redirectToUploadPdfPage = () =>{
        this.props.changePage({currentPageNo: 2});
        this.props.history.push("/main/editBook/PDF/"+this.props.match.params.bookId);
    }
    render(){
        return(
            <div>
            {!this.state.error && this.props.books && 
                !this.state.noDisturbanceMode &&
                    <h1 className="content_title w-100">Currently Reading: {this.props.books[this.props.match.params.bookId].book_title}</h1>

            }
            {!this.state.error && !this.state.noDisturbanceMode && 
                <h1 className="distractionFreeMode" onClick={() => {this.setState({noDisturbanceMode: true});}}><input type="checkbox" />Enter in Distraction Free Mode</h1>
            }
            <div className="rbpdf">
            {!this.state.loading ?
                !this.state.noDisturbanceMode ?
            <PDFReader pdfDoc = {this.LoadedDocument}/>
            :<PDFReaderNoDisturbance pdfDoc={this.LoadedDocument} switchNormalMode={this.switchNormalMode} bookName={this.props.books[this.props.match.params.bookId].book_title}/>
            : !this.state.error &&
            <div className="loader">
                <div></div>
                <h1>Please Wait...</h1>
            </div>
            }
            {this.state.error && 
                <div className="userWelcome inTheReadBookPdf">
                    <h1 className="userWelcomeTypingTitle">Hello {this.props.name},</h1>
                    <h2 className="userWelcomeTypingSubTitle">There is no actual pdf uploaded by you for reading. </h2>
                    <h3 className="userWelcomeTypingSubTitleSubTitle" onClick={this.redirectToUploadPdfPage}>Please click here to Add Or Upload a book.</h3>
                </div>
            }
            </div>
            </div>
        );
    };
};

function mapStateToProps(state){
    return {
     books: state.AllBooks.books,
     name: state.user.name
 }
}

export default connect(mapStateToProps, {fetch_books, changePage, chRecViewed})(ReadBookPDF);